import { render, staticRenderFns } from "./WeRecommendTender.vue?vue&type=template&id=6292cccc"
import script from "./WeRecommendTender.vue?vue&type=script&lang=js"
export * from "./WeRecommendTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports